import React from 'react';
import {
  ColumnDirective,
  ColumnsDirective,
  Filter,
  GridComponent,
  Inject,
  Page,
  Sort,
} from '@syncfusion/ej2-react-grids';
import type { ApiActivityLog } from '../../../models/apiActivity';

/** A grid-bound row: the API row plus precomputed display fields (company name, Yes/No). */
export interface ApiActivityRow extends ApiActivityLog {
  companyName: string;
  sensitiveLabel: string;
}

export interface ApiActivityGridProps {
  rows: ApiActivityRow[];
}

const GRID_PAGE_SIZE = 25;

export function ApiActivityGrid({ rows }: ApiActivityGridProps): React.ReactElement {
  return (
    <div className="bo-grid-wrap bo-card">
      <GridComponent
        dataSource={rows}
        allowPaging
        allowSorting
        allowFiltering
        pageSettings={{ pageSize: GRID_PAGE_SIZE, pageSizes: [10, 25, 50, 100] }}
        filterSettings={{ type: 'Menu' }}
        width="100%"
        height={520}
      >
        <ColumnsDirective>
          <ColumnDirective field="createdAt" headerText="When (UTC)" width={180} />
          <ColumnDirective field="route" headerText="Endpoint" width={240} />
          <ColumnDirective field="httpMethod" headerText="Method" width={100} />
          <ColumnDirective field="statusCode" headerText="Status" width={100} textAlign="Right" type="number" />
          <ColumnDirective field="durationMs" headerText="Duration (ms)" width={130} textAlign="Right" type="number" />
          <ColumnDirective field="responseSizeBytes" headerText="Size (bytes)" width={130} textAlign="Right" type="number" />
          <ColumnDirective field="authScheme" headerText="Scheme" width={120} />
          <ColumnDirective field="companyName" headerText="Company" width={180} />
          <ColumnDirective field="userId" headerText="User" width={180} />
          <ColumnDirective field="sensitiveLabel" headerText="Sensitive" width={110} />
        </ColumnsDirective>
        <Inject services={[Page, Sort, Filter]} />
      </GridComponent>
    </div>
  );
}
